module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "start"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('i', [_vm._v("No pseudonyms have been used in this book, no composite characters. Everyone who appears in this book is real. They have contributed their stories generously.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5fdb866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-intro.vue
// module id = 72
// module chunks = 0